module.exports = __webpack_public_path__ + "static/media/log-out2.f781d5c2.png";